document.documentElement.classList.remove('no-js');

/* Theme-level safety net while the storefront is in pre-launch mode. */
if (document.body.dataset.prelaunchMode === 'true') {
  document.addEventListener('submit', (event) => {
    const action = event.target?.getAttribute?.('action') || '';
    const isCartAdd = action.includes('/cart/add');
    const isCheckout = event.submitter?.name === 'checkout';

    if (isCartAdd || isCheckout) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target.closest('[name="checkout"], .shopify-payment-button')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}

/* ========================================================
   EARLY ACCESS POPUP
======================================================== */

(() => {
  const modal = document.querySelector('[data-early-access-modal]');

  if (!modal) return;

  const triggers = document.querySelectorAll(
    'a[href$="#SoftPanicEarlyAccess"]'
  );
  const closeButtons = modal.querySelectorAll('[data-early-access-close]');
  const firstField = modal.querySelector('input:not([type="hidden"])');
  const statusMessage = modal.querySelector(
    '[data-early-access-success], [data-early-access-error]'
  );
  let previousFocus = null;

  const openModal = () => {
    previousFocus = document.activeElement;

    if (typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }

    window.setTimeout(() => {
      (statusMessage || firstField || modal).focus();
    }, 0);
  };

  const closeModal = () => {
    if (typeof modal.close === 'function') {
      if (modal.open) modal.close();
    } else {
      modal.removeAttribute('open');
    }
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openModal();
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });

  modal.addEventListener('close', () => {
    previousFocus?.focus?.();
  });

  if (statusMessage) openModal();
})();


/* ========================================================
   MOBILE NAVIGATION
======================================================== */

(() => {
  const menu =
    document.querySelector('[data-mobile-nav]') ||
    document.querySelector('.mobile-drawer');

  const panel =
    menu?.querySelector('.mobile-drawer__panel');

  const openBtn =
    document.querySelector('[data-menu-toggle]') ||
    document.querySelector('.site-header__menu');

  const closeBtn =
    menu?.querySelector('[data-menu-close]') ||
    menu?.querySelector('.mobile-drawer__top .icon-button');

  if (!menu || !openBtn) {
    return;
  }


  /* =====================================================
     OPEN MENU
  ===================================================== */

  const openMenu = () => {
    menu.hidden = false;

    openBtn.setAttribute(
      'aria-expanded',
      'true'
    );

    document.body.style.overflow = 'hidden';
  };


  /* =====================================================
     CLOSE MENU
  ===================================================== */

  const closeMenu = () => {
    menu.hidden = true;

    openBtn.setAttribute(
      'aria-expanded',
      'false'
    );

    document.body.style.overflow = '';
  };


  /* =====================================================
     HAMBURGER BUTTON
  ===================================================== */

  openBtn.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (menu.hidden) {
      openMenu();
    } else {
      closeMenu();
    }
  });


  /* =====================================================
     X / CLOSE BUTTON
  ===================================================== */

  closeBtn?.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    closeMenu();
  });


  /* =====================================================
     TAP / CLICK ANYWHERE OUTSIDE MENU PANEL

     This listens on the entire document in capture mode.
     It therefore works even if the backdrop itself is not
     the element receiving the tap.
  ===================================================== */

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (menu.hidden) {
        return;
      }

      const clickedInsidePanel =
        panel?.contains(event.target);

      const clickedHamburger =
        openBtn.contains(event.target);

      if (
        !clickedInsidePanel &&
        !clickedHamburger
      ) {
        closeMenu();
      }
    },
    true
  );


  /* =====================================================
     ESCAPE KEY
  ===================================================== */

  document.addEventListener('keydown', (event) => {
    if (
      event.key === 'Escape' &&
      !menu.hidden
    ) {
      closeMenu();
    }
  });


  /* =====================================================
     CLOSE AFTER SELECTING A MENU LINK
  ===================================================== */

  menu
    .querySelectorAll('.mobile-nav a')
    .forEach((link) => {
      link.addEventListener('click', () => {
        closeMenu();
      });
    });
})();


/* ========================================================
   QUANTITY BUTTONS
======================================================== */

document
  .querySelectorAll('[data-quantity], .cart-item')
  .forEach((root) => {
    const input = root.querySelector('input[type="number"]');

    if (!input) return;

    const minusButton = root.querySelector('[data-qty-minus]');
    const plusButton = root.querySelector('[data-qty-plus]');

    minusButton?.addEventListener('click', () => {
      const min = Number(input.min || 0);
      const currentValue = Number(input.value || 0);

      input.value = Math.max(
        min,
        currentValue - 1
      );

      input.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    });

    plusButton?.addEventListener('click', () => {
      const currentValue = Number(input.value || 0);

      input.value = currentValue + 1;

      input.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    });
  });


/* ========================================================
   PRODUCT PAGE
======================================================== */

document
  .querySelectorAll('[data-product-root]')
  .forEach((root) => {

    const prelaunchMode =
      root.dataset.prelaunchMode === 'true';

    const preorderMode =
      root.dataset.preorderMode === 'true';

    const select =
      root.querySelector('[data-variant-select]');

    const priceWrap =
      root.querySelector('[data-price]');

    const gallery =
      root.querySelector('[data-product-gallery]');

    const addToCartButton =
      root.querySelector('[data-add-to-cart]');

    const addToCartText =
      root.querySelector('[data-add-to-cart-text]');

    const optionGroups =
      Array.from(
        root.querySelectorAll('[data-option-group]')
      );


    /* =====================================================
       GET ALL GALLERY ITEMS
    ===================================================== */

    const getGalleryItems = () => {
      if (!gallery) {
        return [];
      }

      return Array.from(
        gallery.querySelectorAll(
          '.product-gallery__item'
        )
      );
    };


    /* =====================================================
       GET CURRENT SHOPIFY VARIANT
    ===================================================== */

    const getCurrentVariant = () => {
      if (!select) {
        return null;
      }

      return (
        select.options[
          select.selectedIndex
        ] || null
      );
    };


    /* =====================================================
       GET CURRENTLY SELECTED COLOR / SIZE BUTTONS
    ===================================================== */

    const getSelectedValues = () => {
      const selectedValues = {};

      optionGroups.forEach((group) => {
        const position =
          Number(
            group.dataset.optionPosition
          );

        const selectedButton =
          group.querySelector(
            '[data-option-button].is-selected'
          );

        if (selectedButton) {
          selectedValues[position] =
            selectedButton.dataset.optionValue;
        }
      });

      return selectedValues;
    };


    /* =====================================================
       FIND SHOPIFY VARIANT MATCHING SELECTED BUTTONS
    ===================================================== */

    const findMatchingVariant = () => {
      if (!select) {
        return null;
      }

      const selectedValues =
        getSelectedValues();

      return (
        Array.from(select.options).find(
          (variant) => {

            return optionGroups.every(
              (group) => {

                const position =
                  Number(
                    group.dataset.optionPosition
                  );

                const selectedValue =
                  selectedValues[position];

                const variantValue =
                  variant.dataset[
                    `option${position}`
                  ];

                return (
                  variantValue ===
                  selectedValue
                );
              }
            );
          }
        ) || null
      );
    };


    /* =====================================================
       SYNC BUTTONS TO CURRENT VARIANT

       This is especially important when opening:
       ?variant=123456
    ===================================================== */

    const syncButtonsFromVariant = () => {
      const variant =
        getCurrentVariant();

      if (!variant) {
        return;
      }

      optionGroups.forEach((group) => {
        const position =
          Number(
            group.dataset.optionPosition
          );

        const selectedValue =
          variant.dataset[
            `option${position}`
          ];

        const buttons =
          group.querySelectorAll(
            '[data-option-button]'
          );

        buttons.forEach((button) => {
          const isSelected =
            button.dataset.optionValue ===
            selectedValue;

          button.classList.toggle(
            'is-selected',
            isSelected
          );

          button.setAttribute(
            'aria-pressed',
            isSelected
              ? 'true'
              : 'false'
          );
        });

        const selectedLabel =
          group.querySelector(
            '[data-option-selected]'
          );

        if (selectedLabel) {
          selectedLabel.textContent =
            selectedValue || '';
        }
      });
    };


    /* =====================================================
       UPDATE PRICE
    ===================================================== */

    const updatePrice = () => {
      if (
        !select ||
        !priceWrap
      ) {
        return;
      }

      const variant =
        getCurrentVariant();

      if (!variant) {
        return;
      }

      const current =
        priceWrap.querySelector(
          '.price__current'
        );

      const compare =
        priceWrap.querySelector(
          '.price__compare'
        );

      if (
        current &&
        variant.dataset.price
      ) {
        current.textContent =
          variant.dataset.price;
      }


      if (variant.dataset.compare) {

        if (compare) {
          compare.textContent =
            variant.dataset.compare;
        } else {
          priceWrap.insertAdjacentHTML(
            'beforeend',
            `<s class="price__compare">${variant.dataset.compare}</s>`
          );
        }

        priceWrap.classList.add(
          'price--sale'
        );

      } else {

        compare?.remove();

        priceWrap.classList.remove(
          'price--sale'
        );

      }
    };


    /* =====================================================
       UPDATE ADD TO CART BUTTON
    ===================================================== */

    const updateAddToCart = () => {
      if (
        !select ||
        !addToCartButton
      ) {
        return;
      }

      const variant =
        getCurrentVariant();

      if (!variant) {
        return;
      }

      const available =
        variant.dataset.available === 'true';

      addToCartButton.disabled =
        !available;

      if (addToCartText) {
        addToCartText.textContent =
          available
            ? (preorderMode ? 'Preorder' : 'Add to cart')
            : 'Sold out';
      }
    };


    /* =====================================================
       UPDATE URL WITH VARIANT ID
    ===================================================== */

    const updateVariantURL = () => {
      if (!select) {
        return;
      }

      const variantId =
        select.value;

      if (!variantId) {
        return;
      }

      const url =
        new URL(
          window.location.href
        );

      url.searchParams.set(
        'variant',
        variantId
      );

      window.history.replaceState(
        {},
        '',
        url
      );
    };


    /* =====================================================
       UPDATE PRODUCT GALLERY

       Order:
       1. Lifestyle photos matching selected color
       2. Shared lifestyle photos
       3. Product/mockup photos matching selected color
       4. Shared product photos

       Images for other colors are hidden.
    ===================================================== */

    const updateVariantImages = () => {
      if (!gallery) {
        return;
      }

      const variant =
        getCurrentVariant();

      const selectedColor =
        variant?.dataset.color || '';

      const items =
        getGalleryItems();

      if (!items.length) {
        return;
      }

      const visibleItems = [];
      const hiddenItems = [];


      /* Determine visible images */

      items.forEach((item) => {
        const mediaColor =
          item.dataset.productMediaColor || '';

        const shouldShow =
          !selectedColor ||
          mediaColor === selectedColor ||
          mediaColor === '';

        item.hidden =
          !shouldShow;

        item.classList.toggle(
          'is-hidden',
          !shouldShow
        );

        if (shouldShow) {
          visibleItems.push(item);
        } else {
          hiddenItems.push(item);
        }
      });


      /* Sort visible images */

      visibleItems.sort((a, b) => {

        const getPriority = (item) => {

          const mediaColor =
            item.dataset.productMediaColor || '';

          const mediaKind =
            item.dataset.mediaKind || 'product';

          const isLifestyle =
            mediaKind === 'lifestyle';

          const isSelectedColor =
            selectedColor &&
            mediaColor === selectedColor;

          const isShared =
            mediaColor === '';


          /* Selected color lifestyle */

          if (
            isSelectedColor &&
            isLifestyle
          ) {
            return 0;
          }


          /* Shared lifestyle */

          if (
            isShared &&
            isLifestyle
          ) {
            return 1;
          }


          /* Selected color product */

          if (isSelectedColor) {
            return 2;
          }


          /* Shared product */

          if (isShared) {
            return 3;
          }


          return 4;
        };


        const priorityDifference =
          getPriority(a) -
          getPriority(b);

        if (
          priorityDifference !== 0
        ) {
          return priorityDifference;
        }


        /* Keep Shopify's original order */

        const aOrder =
          Number(
            a.dataset.mediaOrder || 0
          );

        const bOrder =
          Number(
            b.dataset.mediaOrder || 0
          );

        return aOrder - bOrder;
      });


      /* Reorder gallery */

      [
        ...visibleItems,
        ...hiddenItems
      ].forEach((item) => {
        gallery.appendChild(item);
      });
    };


    /* =====================================================
       UPDATE OPTION AVAILABILITY

       Fades / crosses out combinations that don't exist
       or aren't available.
    ===================================================== */

    const updateOptionAvailability = () => {
      if (!select) {
        return;
      }

      const variants =
        Array.from(
          select.options
        );

      const selectedValues =
        getSelectedValues();


      optionGroups.forEach((group) => {

        const groupPosition =
          Number(
            group.dataset.optionPosition
          );

        const groupName =
          String(group.dataset.optionName || '')
            .trim()
            .toLowerCase();

        const isColorGroup =
          groupName === 'color' ||
          groupName === 'colour';

        const buttons =
          group.querySelectorAll(
            '[data-option-button]'
          );


        buttons.forEach((button) => {

          const testValue =
            button.dataset.optionValue;


          const hasMatchingVariant =
            variants.some((variant) => {

              if (
                !prelaunchMode &&
                !preorderMode &&
                variant.dataset.available !==
                'true'
              ) {
                return false;
              }

              /* A color stays visible when it exists anywhere on the
                 product. Size and internal category should not hide it. */
              if (isColorGroup) {
                return (
                  variant.dataset[
                    `option${groupPosition}`
                  ] === testValue
                );
              }


              return optionGroups.every(
                (otherGroup) => {

                  const position =
                    Number(
                      otherGroup.dataset.optionPosition
                    );


                  /*
                   * Test the button we're checking.
                   * Keep the currently selected
                   * values for other options.
                   */
                  const neededValue =
                    position === groupPosition
                      ? testValue
                      : selectedValues[position];


                  return (
                    variant.dataset[
                      `option${position}`
                    ] ===
                    neededValue
                  );
                }
              );
            });


          const currentlySelected =
            button.classList.contains(
              'is-selected'
            );


          button.classList.toggle(
            'is-unavailable',
            !hasMatchingVariant &&
            !currentlySelected
          );


          button.setAttribute(
            'aria-disabled',
            !hasMatchingVariant &&
            !currentlySelected
              ? 'true'
              : 'false'
          );
        });
      });
    };


    /* =====================================================
       UPDATE EVERYTHING
    ===================================================== */

    const updateVariant = () => {
      syncButtonsFromVariant();

      updatePrice();

      updateAddToCart();

      updateVariantURL();

      updateVariantImages();

      updateOptionAvailability();
    };


    /* =====================================================
       COLOR / SIZE BUTTON CLICKS
    ===================================================== */

    root
      .querySelectorAll(
        '[data-option-button]'
      )
      .forEach((button) => {

        button.addEventListener(
          'click',
          () => {

            /*
             * Don't select combinations
             * we've marked unavailable.
             */

            if (
              button.classList.contains(
                'is-unavailable'
              )
            ) {
              return;
            }


            const group =
              button.closest(
                '[data-option-group]'
              );

            if (!group) {
              return;
            }


            /*
             * Select clicked button.
             */

            group
              .querySelectorAll(
                '[data-option-button]'
              )
              .forEach(
                (groupButton) => {

                  const isSelected =
                    groupButton === button;

                  groupButton.classList.toggle(
                    'is-selected',
                    isSelected
                  );

                  groupButton.setAttribute(
                    'aria-pressed',
                    isSelected
                      ? 'true'
                      : 'false'
                  );
                }
              );


            /*
             * Update label beside:
             *
             * Color
             * Size
             */

            const selectedLabel =
              group.querySelector(
                '[data-option-selected]'
              );

            if (selectedLabel) {
              selectedLabel.textContent =
                button.dataset.optionValue;
            }


            /*
             * Find exact Shopify variant
             * matching current choices.
             */

            const matchingVariant =
              findMatchingVariant();


            if (!matchingVariant) {
              return;
            }


            /*
             * Update Shopify's hidden
             * variant selector.
             */

            select.value =
              matchingVariant.value;


            /*
             * Update page.
             */

            updateVariant();
          }
        );
      });


    /* =====================================================
       INITIAL PRODUCT PAGE LOAD
    ===================================================== */

    if (select) {
      syncButtonsFromVariant();

      updateVariant();
    } else {
      /*
       * Products with only one variant
       * still need their gallery.
       */

      updateVariantImages();
    }

  });

  /* ========================================================
   PRODUCT CARD COLOR PREVIEW
======================================================== */

(() => {

  const saveOriginalState = (card) => {

    if (!card) return;

    const image =
      card.querySelector(
        '[data-product-card-image]'
      );

    if (
      image &&
      !image.dataset.originalCardSrc
    ) {

      image.dataset.originalCardSrc =
        image.getAttribute('src') || '';

      image.dataset.originalCardSrcset =
        image.getAttribute('srcset') || '';

    }


    card
      .querySelectorAll(
        '[data-product-card-link]'
      )
      .forEach((link) => {

        if (
          !link.dataset.originalCardHref
        ) {
          link.dataset.originalCardHref =
            link.getAttribute('href') || '';
        }

      });

  };


  const previewColor = (swatch) => {

    const card =
      swatch.closest(
        '[data-product-card]'
      );

    if (!card) return;


    saveOriginalState(card);


    const image =
      card.querySelector(
        '[data-product-card-image]'
      );


    const newSrc =
      swatch.dataset.cardImageSrc;

    const newSrcset =
      swatch.dataset.cardImageSrcset;

    const variantUrl =
      swatch.dataset.cardVariantUrl;


    if (image && newSrc) {

      image.setAttribute(
        'src',
        newSrc
      );


      if (newSrcset) {

        image.setAttribute(
          'srcset',
          newSrcset
        );

      }

    }


    if (variantUrl) {

      card
        .querySelectorAll(
          '[data-product-card-link]'
        )
        .forEach((link) => {

          link.setAttribute(
            'href',
            variantUrl
          );

        });

    }


    card
      .querySelectorAll(
        '[data-card-color-swatch]'
      )
      .forEach((item) => {

        item.classList.remove(
          'is-previewing'
        );

      });


    swatch.classList.add(
      'is-previewing'
    );


    card.classList.add(
      'is-color-previewing'
    );

  };


  const restoreCard = (card) => {

    if (!card) return;


    const image =
      card.querySelector(
        '[data-product-card-image]'
      );


    if (
      image &&
      image.dataset.originalCardSrc
    ) {

      image.setAttribute(
        'src',
        image.dataset.originalCardSrc
      );


      if (
        image.dataset.originalCardSrcset
      ) {

        image.setAttribute(
          'srcset',
          image.dataset.originalCardSrcset
        );

      } else {

        image.removeAttribute(
          'srcset'
        );

      }

    }


    card
      .querySelectorAll(
        '[data-product-card-link]'
      )
      .forEach((link) => {

        if (
          link.dataset.originalCardHref
        ) {

          link.setAttribute(
            'href',
            link.dataset.originalCardHref
          );

        }

      });


    card
      .querySelectorAll(
        '[data-card-color-swatch]'
      )
      .forEach((swatch) => {

        swatch.classList.remove(
          'is-previewing'
        );

      });


    card.classList.remove(
      'is-color-previewing'
    );

  };


  /* ==========================================
     DESKTOP HOVER
     ========================================== */

  document.addEventListener(
    'pointerover',
    (event) => {

      const swatch =
        event.target.closest(
          '[data-card-color-swatch]'
        );

      if (!swatch) return;


      if (
        event.relatedTarget &&
        swatch.contains(
          event.relatedTarget
        )
      ) {
        return;
      }


      previewColor(swatch);

    }
  );


  /* ==========================================
     LEAVING SWATCH AREA
     ========================================== */

  document.addEventListener(
    'pointerout',
    (event) => {

      const swatchArea =
        event.target.closest(
          '[data-card-color-swatches]'
        );

      if (!swatchArea) return;


      if (
        event.relatedTarget &&
        swatchArea.contains(
          event.relatedTarget
        )
      ) {
        return;
      }


      const card =
        swatchArea.closest(
          '[data-product-card]'
        );


      restoreCard(card);

    }
  );


  /* ==========================================
     KEYBOARD ACCESSIBILITY
     ========================================== */

  document.addEventListener(
    'focusin',
    (event) => {

      const swatch =
        event.target.closest(
          '[data-card-color-swatch]'
        );

      if (!swatch) return;

      previewColor(swatch);

    }
  );


  document.addEventListener(
    'focusout',
    (event) => {

      const swatchArea =
        event.target.closest(
          '[data-card-color-swatches]'
        );

      if (!swatchArea) return;


      if (
        event.relatedTarget &&
        swatchArea.contains(
          event.relatedTarget
        )
      ) {
        return;
      }


      const card =
        swatchArea.closest(
          '[data-product-card]'
        );


      restoreCard(card);

    }
  );

})();
